export class GroupMapping {
    id: number;
    groupId: number | null;
    countryId: number | null;
    stateId: number | null;
    facilityId: number | null;
    countryName: number | null;
    stateName: number | null;
    facilityName: number | null;
}
